import { defineMeta } from '@/registry/types';

export const formExampleMeta = defineMeta({
  name: 'FormExample',
  level: 'page',
  category: 'example',
  classification: 'custom',
  description: 'Reference create-entity form page (FormPageLayout + FormField).',
  baseLibrary: 'custom',
  importPath: '@/pages/FormExample',
  supportedStates: ['default'],
  designTokens: ['spacing', 'typography'],
  usageExamples: ['<FormExample />'],
  llmSafe: false,
  whenToUse: ['Reference for create/edit form pages'],
  whenNotToUse: ['Production without validation/data wiring'],
});

export default formExampleMeta;
